import styled from "styled-components";
import posed from "react-pose";

const Overlay = styled(
  posed.div({
    enter: {
      opacity: 1,
      transition: {
        stiffness: 600,
        damping: 30
      }
    },
    exit: {
      opacity: 0,
      transition: {
        stiffness: 600,
        damping: 30
      }
    }
  })
)`
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  border-radius: 10px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export default Overlay;
